// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d9afcfcf","453":"5adce8aa","455":"8be6aa5e"}[chunkId] + ".chunk.js";
};